<template>
  <div class="list-item-file smd-panel m-b-20"
       @click="viewFile">
    <div class="file">
      <span class="file-icon ns-x-large-icon ns-icon-ico013"/>
      <div class="text" :class="{'m-l-10': !$isDesktop}">
        <h2 class="list-item-file__title" :class="!$isDesktop ? 'm-b-10 Title1' : 'm-b-20 Title2'">
          {{ computedTitle(fileData) }}
        </h2>
        <text-string :label-id="$isDesktop ? 'txt040__desktop' : 'txt040'"
                     :props="{strings: [fileData.patientname, '']}"
                     :class="{'m-b-5': $isDesktop}"/>
        <p class="gray-400" :class="$isDesktop ? 'Label1' : 'Body3'">{{ fileData.received | formatReceivedDate }}</p>
      </div>
    </div>
    <div class="smd-panel__footer"
         :class="[{'list-item-file__right_btns': $isDesktop}, {'m-t-20': !$isDesktop}]">
      <smd-btn class="list-item-file__view-btn"
               section="5"
               variant="left-enabled">
        <text-string label-id="txt060__desktop"/>
      </smd-btn>
      <smd-btn v-if="!fileData.labresultid"
               class="list-item-file__press-to-order-btn"
               section="5"
               :variant="rightActionBtnVariant"
               @click.stop.prevent="rightActionBtnFn">
        <text-string :label-id="rightActionBtnLabelId"/>
      </smd-btn>
    </div>
  </div>
</template>

<script>
  import TitleMixin from '@/mixins/title-mixin';
  import GetElementString from "@/mixins/get-element-string";
  import LabRequestCouponMixin from "@/mixins/lab-request-coupon-mixin";
  import ShowModalInstructionsMixin from "@/mixins/show-modal-instructions-mixin";

  import Routes from "@/router/routes";

  import {formatDate} from '@/utils/dates';

  import PreviewFileType from '@/reference/preview-file-type';

  export default {
    name: "list-item-file-labtest",
    mixins: [
      GetElementString,
      TitleMixin,
      LabRequestCouponMixin,
      ShowModalInstructionsMixin,
    ],
    filters: {
      formatReceivedDate(date) {
        return formatDate(date, '[Sent on] MMMM DD, YYYY [at] h:mm a');
      },
    },
    props: {
      fileData: {type: Object, required: false},
    },
    computed: {
      rightActionBtnLabelId() {
        return this.fileData.orderid ? 'txt253' : 'txt1413';
      },
      rightActionBtnVariant() {
        return this.fileData.orderid ? 'right-green-enabled' : 'right-blue-enabled';
      },
    },
    methods: {
      goToServices() {
        this.$router.push({name: Routes.SERVICES_ROUTE});
      },
      rightActionBtnFn() {
        if (this.fileData.orderid) {
          this.viewOrderDetails(this.fileData.token, this.fileData.orderid);
        } else {
          this.$router.push({name: Routes.SERVICES_ROUTE});
        }
      },
      viewFile() {
        this.$router.push(
          {
            name: Routes.PREVIEW_FILE_LAB_REQUEST,
            params: {
              file: [this.fileData],
              title: this.computedTitle(this.fileData),
              filesView: true,
              type: PreviewFileType.PREVIEW_TYPE_PRESCRIPTION,
              token: this.fileData.token,
              showCouponButton: false,
            },
          }
        )
      },
    },
  }
</script>

<style lang="scss">
  .list-item-file {
    @extend %layout--flex-col;
    @include responsive(desktop) {
      display: grid;
      grid-template-columns: 1fr 235px;
      align-items: center;
      padding: space(m-base);
      min-height: 160px;
      overflow: hidden;
    }

    cursor: pointer;

    .file {
      @extend %layout--flex-row;
      flex-direction: row;
      align-items: normal;

      @include responsive(desktop) {
        align-items: center;
      }
    }

    .file-icon {
      @include responsive(desktop) {
        font-size: 120px !important;
        margin-right: space(m-base);
      }
    }

    .download-icon {
      align-self: center;
      color: color(gray, text);

      p {
        font-size: 24px;
      }
    }
  }

  .list-item-file__title {
    line-height: 1;
  }

  .list-item-file__right_btns {
    flex-direction: column;
    margin: unset;

    > button {
      width: 100%;
      max-width: 235px;
      min-width: 235px;
    }
  }

  .list-item-file__view-btn, .list-item-file__coupon {
    @extend %layout--flex-center-xy;
    @include responsive(desktop) {
      position: absolute;
      top: 0;
      right: 0;
      height: 90px !important;
      width: 235px !important;
    }
  }

  .list-item-file__press-to-order-btn {
    @include responsive(desktop) {
      position: absolute;
      bottom: 0 !important;
      right: 0 !important;
    }
  }
</style>
